<script>
import {
  shippingMethodListEmits,
  shippingMethodListProps,
  useShippingMethodList
} from "./mixin";
import List from "@/components/molecules/list";
import ListItem from "@/components/molecules/list/list-item";
import ShippingMethod from "@/containers/shipping-method";

export default {
  name: "ShippingMethodListMobile",
  components: {
    List,
    ShippingMethod,
    ListItem
  },
  props: {
    ...shippingMethodListProps()
  },
  emits: [...shippingMethodListEmits()],
  setup(props, context) {
    const {
      modeCommandeHabituel,
      otherModesCommande,
      modeCommandeSelected,
      serviceSelected,
      showOrderDetail
    } = useShippingMethodList(props, context);
    return {
      modeCommandeHabituel,
      otherModesCommande,
      modeCommandeSelected,
      serviceSelected,
      showOrderDetail
    };
  }
};
</script>

<template>
  <div>
    <template v-if="modesCommande.length > 0">
      <template v-if="modeCommandeHabituel">
        <p class="c-shipping-method-list-mobile__step-subtitle u-mb-xs">
          Votre mode de livraison habituel
        </p>
        <ShippingMethod
          class="c-shipping-method-list-mobile__item"
          :mode-commande="modeCommandeHabituel"
          @click="modeCommandeSelected(modeCommandeHabituel)"
          @showOrderDetail="showOrderDetail"
        />
        <p
          v-if="otherModesCommande.length > 0"
          class="c-shipping-method-list-mobile__step-subtitle u-mt-md  u-mb-xs"
        >
          Les autres modes de livraison
        </p>
      </template>
      <List class="c-shipping-method-list-mobile">
        <ListItem
          v-for="mdc in otherModesCommande"
          :key="mdc.type"
        >
          <ShippingMethod
            class="c-shipping-method-list-mobile__item"
            :mode-commande="mdc"
            @click="modeCommandeSelected(mdc)"
            @showOrderDetail="showOrderDetail"
          />
        </ListItem>
      </List>
    </template>
    <template v-else>
      <p class="u-bgcolor-white u-radius-lg u-p-sm u-font-700">
        Désolé, mais aucun mode de livraison n'est disponible pour ce panier dans
        ce magasin pour le moment.
      </p>
    </template>
  </div>
</template>

<style lang="scss" scoped>
@import "@/assets/styles/components/shipping-method-list.scss";
</style>
